import { ProductTagUpdatePage } from '@/features/product-tag/pages/ProductTagUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-tag/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_tag.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductTagUpdatePage,
})
